<template>
  <div
    class="form-check FormCheckbox"
    :class="{
      white, green,
      disabled,
      isLoading,
      hasLabelModel: labelModel,
      'true': isActive,
      'false': !isActive,
    }"

    :data-checked="isActive ? 'true' : 'false'"

    @click="toggle"
  >
    <span class="checkbox-wrapper">
      <span>
        <slot name="before"></slot>
      </span>
      <slot name="checkbox">
        <label v-if="!isLoading" :for="cbId" class="form-check-label">
          <input
            :id="cbId"
            class="form-check-input"
            type="checkbox"
            :disabled="disabled"
            :value="isActive"
            disabled
          />
          <span class="form-check-sign" :class="{grayColor: !isActive && grayColor, rounded}">
            <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" class="check" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
            </svg>
          </span>
        </label>
        <div v-else class="ske">
        </div>
      </slot>
      <span class="checkbox-content bolder">
        <slot></slot>

        <span v-if="falseLabel && !isActive" class="info-label">
          {{ `${falseLabel}`}}
        </span>
        <span v-else-if="trueLabel && isActive" class="info-label">
          {{ `${trueLabel}`}}
        </span>
      </span>

      <div v-if="ske" class="ske"></div>
    </span>
  </div>
</template>

<script>

export default {
  name: 'base-checkbox',
  props: {
    updateOnClick: {
      type: Boolean,
      default: true,
    },
    grayColor: {
      type: Boolean,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },

    falseLabel: {
      type: [String, Boolean],
      default: undefined,
    },
    trueLabel: {
      type: [String, Boolean],
      default: undefined,
    },
    trueValue: {
      type: [String, Boolean],
      default: undefined,
    },
    falseValue: {
      type: [String, Boolean],
      default: undefined,
    },
    
    value: {
      type: [Boolean, String, Number],
      default: false,
    },
    white: Boolean,
    green: Boolean,
    labelModel: [String, Boolean],
    rounded: Boolean,
    disableToggle: {
      type: Boolean,
      required: false,
    },
    disabled: [Boolean, String],
    ske: Boolean,
  },
  data() {
    return {
      cbId: '',
      checked: this.value ? true : false,
    }
  },
  created() {
    this.mapValueToChecked()
    
    this.$emit("input", this.checked)
    this.updateLabelValue()
  },
  mounted() {
    this.cbId = Math.random().toString(16).slice(2)
  },
  methods: {
    updateLabelValue(val = this.checked) {
      let model = val ? this.trueLabel : this.falseLabel
      
      if (this.hasValue) {
        model = val ? this.trueValue : this.falseValue
      }


      this.$emit("update:labelModel", model)
    },
    toggle() {
      console.log(this.disableToggle)
      if (this.disableToggle) return;

      if (this.updateOnClick) {
        this.checked = !this.checked
        this.updateLabelValue()
      } else {
        const newVal = !this.checked
        this.$emit("input", newVal)
        this.updateLabelValue(newVal)
      }
    },
    mapValueToChecked() {
      const model = this.labelModel
      
      if (this.hasValue) {
          if (model === this.trueValue) {
          this.checked = true
          } else if (model === this.falseValue) {
          this.checked = false
        }
      } else if (this.hasLabel) {
          if (model === this.trueLabel) {
          this.checked = true
          } else if (model === this.falseLabel) {
          this.checked = false
        }
      }
    },
  },
  computed: {
    isActive() {
      return this.updateOnClick ? this.checked : this.value 
    },
    hasValue() {
      return this.trueValue !== undefined && this.falseValue !== undefined
    },
    hasLabel() {
      return this.trueLabel !== undefined && this.falseLabel !== undefined
    },
  },
  watch: {
    checked(val) {
      this.$emit("input", val)
      this.updateLabelValue(val)
    },
    value(val) {
      this.checked = val ? true : false
    },
    labelModel() {
      this.mapValueToChecked()
    },
  },
}

</script>

<style>

/* .TableHeader .FormCheckbox {
  font-size: 30px !important;
} */

</style>

<style scoped>

.checkbox-content {
  position: relative;
  transform: translateY(2px);
  display: inline-block;
}

.info-label {
  color: #FF4A55;
  font-style: italic;
  font-weight: 700;
}

.true .info-label {
  color: var(--apple-green);
}

.form-check {
  display: inline-block;
}

.checkbox-wrapper {
  display: inline-block;
  cursor: pointer;
  position: relative;
  transform: translateY(1px) !important;
}

.form-check-label {
  margin-bottom: 5px !important;
}

.ske {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.form-check .form-check-sign::before,
.form-check .form-check-sign::after {
  border: 1px solid rgb(200, 200, 200);
  border-radius: 1px;
  color: transparent !important;
}

.form-check .form-check-sign.rounded::before,
.form-check .form-check-sign.rounded::after {
  border-radius: 100px;
}

.form-check .form-check-sign::before, .form-check .form-check-sign::after {
  width: 13.5px;
  height: 13.5px;
  margin-top: -5px;
}

.isLoading .checkbox-wrapper {
  width: 35px;
  height: 15px;
}

.ske {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 13.5px;
  height: 13.5px;
}

.check {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  margin-left: 1.35px;
  margin-top: 1.6px;
  opacity: 0;
  z-index: 15;
}

.form-check:hover .check {
  opacity: 1;
}

.form-check.true .form-check-sign::before,
.form-check.true .form-check-sign::after {
  background-color: var(--mint-green);
  border: 1px solid var(--mint-green);
}

.form-check.true.green .form-check-sign::before,
.form-check.true.green .form-check-sign::after {
  background-color: var(--apple-green);
  border: 1px solid var(--apple-green);
}

.form-check.white .form-check-sign::before,
.form-check.white .form-check-sign::after {
  border: 1px solid white;
  background-color: transparent;
}

.form-check.white.true .form-check-sign::before,
.form-check.white.true .form-check-sign::after {
  background-color: white;
  border: 1px solid white;
}

.form-check.true .form-check-sign.rounded::before,
.form-check.true .form-check-sign.rounded::after {
  border-radius: 100px;
}

.form-check.white .check {
  color: white;
}

.form-check.true .check {
  opacity: 1;
  color: white !important;
}

.white.true .check {
  opacity: 1;
  color: black !important;
}

</style>
